// The settings also send the items the calculation uses that are hidden since (flagged
// onlyForCalculation). Such an item is offered only while the form still holds it: once deselected,
// the server rejects choosing it again, as it is then a changed selection that isn't visible.
// The array itself is returned when nothing is flagged, so memoized consumers keep their inputs.
export const keepOnlyForCalculationWhileSelected = <T extends { onlyForCalculation?: boolean }>(
  items: T[],
  isSelected: (item: T) => boolean,
): T[] =>
  items.some((item) => item.onlyForCalculation)
    ? items.filter((item) => !item.onlyForCalculation || isSelected(item))
    : items;
